module.exports = __webpack_public_path__ + "media/src/assets/images/success-035aa05ba592909b9fca3d6117cb8480.svg";